import { unifiedAgentEvent } from './unifiedAgentEvent'

export const unifiedAgentCreateAbandonedLogEvent = unifiedAgentEvent<{
  last_tab: string
  prompt_count: number
  build_session_id: string | null
}>('Unified_Agent_Create_Abandoned')
